import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom'
import IAppState from '../../../IAppState';
import {IFinishedJobComponentPropsData, IFinishedJobComponentPropsFunctions} from '../props/IFinishedJobComponentProps';
import FinishedJobComponent from '../components/FinishedJobComponent';
import { ll_fetch } from '../../../tools';
import Actions from "../state/act-results";
import IMainState from '../../../IMainState';
import loadJobInfo from './FinishedJobContainer';
import ActMain from '../../../act-main';
import ActionTypeEnum from '../../../ActionTypeEnum';
import { updateDefaultClause } from 'typescript';


/*async function loadBtcResults(dispatch: any, jobId: string) {
    await ll_fetch(`/api/getBTCMutations?jobId=${jobId}`)
    .then(response => response.json())
    .then(data => dispatch(Actions.BtcResults(data)))
    .catch(err => {
        console.log("FAILED 1")
        console.error(err);
    })
}
async function loadLowRiskResults(dispatch: any, jobId: string) {
    await ll_fetch(`/api/getLowEnergyMutations?jobId=${jobId}`)
    .then(response => response.json())
    .then(data => dispatch(Actions.LowRiskResults(data)))
    .catch(err => {
        console.log("FAILED 2")
        console.error(err);
    })
}

async function loadHighRiskResults(dispatch: any, jobId: string) {
    await ll_fetch(`/api/getHighEnergyMutations?jobId=${jobId}`)
    .then(response => response.json())
    .then(data => dispatch(Actions.HighRiskResults(data)))
    .catch(err => {
        console.log("FAILED 3")
        console.error(err);
    })
}

async function loadCombinedLowRiskResults(dispatch: any, jobId: string) {
    await ll_fetch(`/api/getLowCombinedMutations?jobId=${jobId}`)
    .then(response => response.json())
    .then(data => dispatch(Actions.CombinedLowRiskResults(data)))
    .catch(err => {
        console.log("FAILED 4")
        console.error(err);
    })
}

async function loadCombinedHighRiskResults(dispatch: any, jobId: string) {
    await ll_fetch(`/api/getHighCombinedMutations?jobId=${jobId}`)
    .then(response => response.json())
    .then(data => dispatch(Actions.CombinedHighRiskResults(data)))
    .catch(err => {
        console.log("FAILED 5")
        console.error(err);
    })
}

async function loadAncestralDesigns(dispatch: any, jobId: string){
    await ll_fetch(`/api/getAncestrals?jobId=${jobId}`)
    .then(response => response.json())
    .then(data => dispatch(Actions.ancestralDesigns(data)))
    .catch(err => {
        console.log("FAILED 6");
        console.error(err);
    })
}

async function loadAllResiduesResults(dispatch: any, jobId: string){
    await ll_fetch(`/api/getAllResidues?jobId=${jobId}`)
    .then(response => response.json())
    .then(data => dispatch(Actions.allResidues(data)))
    .catch(err => {
        console.log("FAILED 7");
        console.error(err);
    })
}*/

async function updateData(dispatch: any, data: any){
    dispatch(Actions.BtcResults(data.btc));
    dispatch(Actions.LowRiskResults(data.lowEnergy));
    dispatch(Actions.HighRiskResults(data.highEnergy));
    dispatch(Actions.CombinedLowRiskResults(data.lowCombined));
    dispatch(Actions.CombinedHighRiskResults(data.highCombined));
    dispatch(Actions.ancestralDesigns(data.ancestrals));
    dispatch(Actions.allResidues(data.allResidues));
    dispatch(Actions.setTypes(data.types));
    dispatch(Actions.setMapping(data.chainMapping));
    dispatch(Actions.setResultPDB(data.pdbId))
}


const mapStateToProps = ({ jobState,mainState }: IAppState, ownProps: { jobId: string }): IFinishedJobComponentPropsData => {

    return {
        jobId: ownProps.jobId,
        BTCmutations : mainState.BTCmutations,
        LowRiskMutations : mainState.LowRiskMutations,
        HighRiskMutations : mainState.HighRiskMutations,
        CombinedLowRiskMutations : mainState.CombinedLowRiskMutations,
        CombinedHighRiskMutations : mainState.CombinedHighRiskMutations,
        ancestralDesigns : mainState.ancestralDesigns,
        allResidues : mainState.allResidues,
        CustomMutantMutations : mainState.CustomMutantMutations,
        types : mainState.types, 

        jobState: jobState,
        finished: jobState.jobInfo !== null && jobState.jobInfo.status === 5,
        ...mainState,
    };
}

const mapDispatchToProps = (dispatch): IFinishedJobComponentPropsFunctions => ({
    /*loadBtcResults: (jobId: string) => loadBtcResults(dispatch, jobId),
    loadLowRiskResults: (jobId: string) => loadLowRiskResults(dispatch, jobId),
    loadHighRiskResults: (jobId: string) => loadHighRiskResults(dispatch, jobId),
    loadCombinedLowRiskResults: (jobId: string) => loadCombinedLowRiskResults(dispatch, jobId),
    loadCombinedHighRiskResults: (jobId: string) => loadCombinedHighRiskResults(dispatch, jobId),
    loadAncestralDesigns: (jobId: string) => loadAncestralDesigns(dispatch, jobId),
    loadAllResiduesResults: (jobId: string) => loadAllResiduesResults(dispatch, jobId),*/
    loadJobInfo: (jobId: string, clear: boolean, succCallback: any) => loadJobInfo(dispatch, jobId, clear, succCallback),
    addCustomMutantMutations: (mutation: any) => dispatch(ActMain.addCustomMutantMutations(mutation)),
    updateJobStatus: (finished: boolean) => dispatch(ActMain.setResultsLoaded(finished)),
    updateData: (data: any) => updateData(dispatch, data),
})


const FinishedJobContainer = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(FinishedJobComponent))

export default FinishedJobContainer;
